import React from 'react';
import { Clock, CheckCircle } from 'lucide-react';


export default function RStrategyTimeline({ asset, hasTriageResult, strategyKey }) {
  if (!hasTriageResult || !strategyKey || !asset || !asset.estimatedTriageTimeline || !asset.estimatedTriageTimeline[strategyKey]) {
    return <p className="text-gray-500">The execution timeline will appear here after a strategy is determined.</p>;
  }

  const timelineSteps = asset.estimatedTriageTimeline[strategyKey];
  if (!timelineSteps || timelineSteps.length === 0) {
    return <p className="text-red-500">No defined timeline for strategy {strategyKey}.</p>;
  }

  let currentDay = 0;

  return (
    <div className="relative pl-4">
      {timelineSteps.map((step, index) => {
        const startDay = currentDay;
        currentDay += step.durationDays;
        const totalDays = currentDay;
        const isLast = index === timelineSteps.length - 1;
        const riskColor = step.risk === 'High' ? 'text-red-500' : step.risk === 'Medium' ? 'text-orange-500' : 'text-green-500';

        return (
          <div key={index} className="relative mb-8 pb-1">
            {!isLast && (
              <div className="absolute left-0 top-0 h-full w-0.5 bg-gray-200 ml-0.5"></div>
            )}
            <div className="absolute -left-2 top-0 w-4 h-4 rounded-full bg-emerald-600 border-4 border-white z-10"></div>

            <div className="pl-6">
              <div className="text-sm text-gray-500 mb-1 flex items-center">
                <Clock className='w-4 h-4 mr-1 text-indigo-400' />
                Day {startDay} – Day {totalDays}
              </div>
              <h4 className={`font-semibold text-gray-900 flex items-center`}>
                {isLast ? <CheckCircle className='w-4 h-4 mr-2 text-emerald-500' /> : <span className="w-4 h-4 mr-2" />}
                {step.step}
              </h4>
              {step.risk !== 'N/A' && (
                <p className="text-xs mt-1">Risk Profile: <span className={riskColor}>{step.risk}</span></p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
